import { IFormTypeService } from "../../service/formconfiguration/FormTypeService";

export default class PublishFormVersionInteractor {
  private formTypeService: IFormTypeService;

  constructor(formTypeService) {
    this.formTypeService = formTypeService;
  }

  async execute(formTypeCode: string) {
    await this.formTypeService.publishFormVersion(formTypeCode);
  }
}
